import { SalvFieldHeader, Size } from '@salvapp/ui-components';
import React from 'react';
import ExternalLink from '../../common/ExternalLink';
import SegmentsEditor from './SegmentsEditor';

interface Props {
  isTransactionScenario: boolean;
  isPeriodicEntity: boolean;
  isDisabled: boolean;
  isTesting?: boolean;
  withDescription?: boolean;
}

const TriggeringSegments = ({
  isTransactionScenario,
  isPeriodicEntity,
  isDisabled,
  isTesting = false,
  withDescription = true,
}: Props) => {
  const isExcludedSegmentsDisabled = isPeriodicEntity && !isTesting;
  const excludedSegmentsDescription = isExcludedSegmentsDisabled
    ? ''
    : 'If the Entity has any Segments matching the Excluded Segments this Scenario will be skipped instead. ';

  return (
    <div>
      <SalvFieldHeader
        label={'Trigger for'}
        size={Size.MEDIUM}
        description={
          withDescription ? (
            <>
              {'Use Segments to specify which Entities cause this Scenario to run. An Entity with Segments matching the Included Segments will trigger the Scenario. ' +
                excludedSegmentsDescription +
                'Read more '}
              <ExternalLink title={'here'} link={'https://help.salv.com/en/articles/239805-trigger-for-in-scenarios'} />
            </>
          ) : undefined
        }
      />
      <SegmentsEditor
        type={'INCLUDED'}
        isTransactionScenario={isTransactionScenario}
        isDisabled={isDisabled}
        withDescription={withDescription}
        className={'m-l-8'}
      />
      {!isExcludedSegmentsDisabled && (
        <SegmentsEditor
          type={'EXCLUDED'}
          isTransactionScenario={isTransactionScenario}
          isDisabled={isDisabled}
          withDescription={withDescription}
          className={'m-l-8 m-t-8'}
        />
      )}
    </div>
  );
};

export default TriggeringSegments;
